import { Virtualizer } from '@tanstack/react-virtual';
import { injectable } from 'inversify';

@injectable()
export class VirtualizerService {
  private virtualizerInstance: Virtualizer<Window, Element> | null = null;

  setVirtualizer(virtualizer: Virtualizer<Window, Element>): void {
    this.virtualizerInstance = virtualizer;
  }

  getVirtualizer(): Virtualizer<Window, Element> | null {
    return this.virtualizerInstance;
  }

  scrollToPage(pageNumber: number): void {
    if (!this.virtualizerInstance) {
      console.warn('Virtualizer not initialized');
      return;
    }

    const pageIndex = pageNumber - 1;

    this.virtualizerInstance.scrollToIndex(pageIndex, {
      behavior: 'auto',
      align: 'start',
    });
  }

  scrollToIndex(
    index: number,
    options?: {
      behavior?: 'auto' | 'smooth';
      align?: 'start' | 'center' | 'end';
    }
  ): void {
    if (!this.virtualizerInstance) {
      console.warn('Virtualizer not initialized');
      return;
    }

    this.virtualizerInstance.scrollToIndex(index, options);
  }

  getTotalSize(): number {
    return this.virtualizerInstance?.getTotalSize() ?? 0;
  }

  getVirtualItems() {
    return this.virtualizerInstance?.getVirtualItems() ?? [];
  }
}
